export default {
  root: ({ props, context, parent, attrs }) => {
    return {
      class: [
        'relative',

        // Alignments
        'items-center inline-flex text-center align-bottom justify-center',

        // Sizes & Spacing
        'leading-[normal]',
        {
          'text-text-sm px-2 py-1': props.size === 'xs' && !attrs['icon-only'],
          'text-text-md px-4 py-2': props.size === 'small' && !attrs['icon-only'],
          'text-lg px-6 py-3': (props.size === null || props.size === 'md') && !attrs['icon-only'],
          'text-xl px-6 py-3': props.size === 'large' && !attrs['icon-only'],
          'text-display-sm px-8 py-4': props.size === 'xl' && !attrs['icon-only'],
          'w-6 h-6': props.size === 'xs' && attrs['icon-only'] === true,
          'w-8 h-8': props.size === 'small' && attrs['icon-only'] === true,
          'w-10 h-10': (props.size === null || props.size === 'md') && attrs['icon-only'] === true
        },

        // Shapes
        { 'shadow-lg': props.raised },
        { 'rounded-xs': !props.rounded, 'rounded-full': props.rounded },
        {
          'rounded-none first:rounded-l-md last:rounded-r-md': parent.instance.$name == 'InputGroup'
        },

        // Link Button
        { 'text-primary-600 bg-transparent border-transparent': props.link },

        // Plain Button
        {
          'text-white bg-gray-500 border border-gray-500':
            props.plain && !props.outlined && !props.text
        },
        // Plain Text Button
        { 'text-surface-500': props.plain && props.text },
        // Plain Outlined Button
        { 'text-surface-500 border border-gray-500': props.plain && props.outlined },

        // Text Button
        { 'bg-transparent border-transparent': props.text && !props.plain },

        // Outlined Button
        { 'bg-transparent border': props.outlined && !props.plain },

        // --- Severity Buttons ---

        // Primary Button
        {
          'text-white dark:text-surface-900':
            !props.link &&
            props.severity === null &&
            !props.text &&
            !props.outlined &&
            !props.plain &&
            attrs['gb-theme'] === null,
          'bg-primary-400 dark:bg-primary-400':
            !props.link &&
            props.severity === null &&
            !props.text &&
            !props.outlined &&
            !props.plain &&
            attrs['gb-theme'] === null,
          'border border-primary-400 dark:border-primary-400':
            !props.link &&
            props.severity === null &&
            !props.text &&
            !props.outlined &&
            !props.plain &&
            attrs['gb-theme'] === null &&
            attrs['gb-theme'] !== 'aiSecondary'
        },
        // Primary Text Button
        {
          'text-primary-500 dark:text-primary-400':
            props.text && props.severity === null && !props.plain
        },
        // Primary Outlined Button
        {
          'text-primary-500 border border-primary-500 hover:bg-primary-300/20':
            props.outlined && props.severity === null && !props.plain && attrs['gb-theme'] === null
        },

        // Secondary Button
        {
          'text-white dark:text-surface-900':
            props.severity === 'secondary' && !props.text && !props.outlined && !props.plain,
          'bg-surface-500 dark:bg-surface-400':
            props.severity === 'secondary' && !props.text && !props.outlined && !props.plain,
          'border border-surface-500 dark:border-surface-400':
            props.severity === 'secondary' && !props.text && !props.outlined && !props.plain
        },
        // Secondary Text Button
        {
          'text-surface-500 dark:text-surface-300':
            props.text && props.severity === 'secondary' && !props.plain
        },
        // Secondary Outlined Button
        {
          'text-surface-500 dark:text-surface-300 border border-surface-500 hover:bg-surface-300/20':
            props.outlined && props.severity === 'secondary' && !props.plain
        },

        // Success Button
        {
          'text-white dark:text-green-900':
            props.severity === 'success' && !props.text && !props.outlined && !props.plain,
          'bg-green-500 dark:bg-green-400':
            props.severity === 'success' && !props.text && !props.outlined && !props.plain,
          'border border-green-500 dark:border-green-400':
            props.severity === 'success' && !props.text && !props.outlined && !props.plain
        },
        // Success Text Button
        {
          'text-green-500 dark:text-green-400':
            props.text && props.severity === 'success' && !props.plain
        },
        // Success Outlined Button
        {
          'text-green-500 border border-green-500 hover:bg-green-300/20':
            props.outlined && props.severity === 'success' && !props.plain
        },

        // Info Button
        {
          'text-white dark:text-surface-900':
            props.severity === 'info' && !props.text && !props.outlined && !props.plain,
          'bg-blue-500 dark:bg-blue-400':
            props.severity === 'info' && !props.text && !props.outlined && !props.plain,
          'border border-blue-500 dark:border-blue-400':
            props.severity === 'info' && !props.text && !props.outlined && !props.plain
        },
        // Info Text Button
        {
          'text-blue-500 dark:text-blue-400':
            props.text && props.severity === 'info' && !props.plain
        },
        // Info Outlined Button
        {
          'text-blue-500 border border-blue-500 hover:bg-blue-300/20 ':
            props.outlined && props.severity === 'info' && !props.plain
        },

        // Warning Button
        {
          'text-white dark:text-surface-900':
            props.severity === 'warning' && !props.text && !props.outlined && !props.plain,
          'bg-orange-500 dark:bg-orange-400':
            props.severity === 'warning' && !props.text && !props.outlined && !props.plain,
          'border border-orange-500 dark:border-orange-400':
            props.severity === 'warning' && !props.text && !props.outlined && !props.plain
        },
        // Warning Text Button
        {
          'text-orange-500 dark:text-orange-400':
            props.text && props.severity === 'warning' && !props.plain
        },
        // Warning Outlined Button
        {
          'text-orange-500 border border-orange-500 hover:bg-orange-300/20':
            props.outlined && props.severity === 'warning' && !props.plain
        },

        // Help Button
        {
          'text-white dark:text-surface-900':
            props.severity === 'help' && !props.text && !props.outlined && !props.plain,
          'bg-purple-500 dark:bg-purple-400':
            props.severity === 'help' && !props.text && !props.outlined && !props.plain,
          'border border-purple-500 dark:border-purple-400':
            props.severity === 'help' && !props.text && !props.outlined && !props.plain
        },
        // Help Text Button
        {
          'text-purple-500 dark:text-purple-400':
            props.text && props.severity === 'help' && !props.plain
        },
        // Help Outlined Button
        {
          'text-purple-500 border border-purple-500 hover:bg-purple-300/20':
            props.outlined && props.severity === 'help' && !props.plain
        },

        // Danger Button
        {
          'text-white dark:text-surface-900':
            props.severity === 'danger' && !props.text && !props.outlined && !props.plain,
          'bg-red-500 dark:bg-red-400':
            props.severity === 'danger' && !props.text && !props.outlined && !props.plain,
          'border border-red-500 dark:border-red-400':
            props.severity === 'danger' && !props.text && !props.outlined && !props.plain
        },
        // Danger Text Button
        {
          'text-red-500 dark:text-red-400':
            props.text && props.severity === 'danger' && !props.plain
        },
        // Danger Outlined Button
        {
          'text-red-500 border border-red-500 hover:bg-red-300/20':
            props.outlined && props.severity === 'danger' && !props.plain
        },

        // --- Severity Button States ---
        'focus-visible:outline-none focus-visible:outline-offset-0 focus-visible:ring-2 focus-visible:ring-offset-1',

        // Link
        { 'focus-visible:ring-primary-400/80 dark:focus-visible:ring-primary-300/50': props.link },

        // Plain
        {
          'hover:bg-gray-600 hover:border-gray-600': props.plain && !props.outlined && !props.text
        },
        // Text & Outlined Button
        { 'hover:bg-surface-300/20': props.plain && (props.text || props.outlined) },

        // Primary
        {
          'hover:bg-primary-500 dark:hover:bg-primary-300 hover:border-primary-500 dark:hover:border-primary-300':
            !props.link &&
            props.severity === null &&
            !props.text &&
            !props.outlined &&
            !props.plain &&
            attrs['gb-theme'] === null
        },
        {
          'focus-visible:ring-primary-400 focus-visible:hover:ring-primary-500 dark:focus-visible:ring-primary-300/50':
            props.severity === null && attrs['gb-theme'] === null
        },
        // Text & Outlined Button
        {
          'hover:bg-primary-300/20':
            (props.text || props.outlined) &&
            props.severity === null &&
            !props.plain &&
            attrs['gb-theme'] === null
        },

        // Secondary
        {
          'hover:bg-surface-600 dark:hover:bg-surface-300 hover:border-surface-600 dark:hover:border-surface-300':
            props.severity === 'secondary' && !props.text && !props.outlined && !props.plain
        },
        {
          'focus-visible:ring-surface-400/50 dark:focus-visible:ring-surface-300/50':
            props.severity === 'secondary'
        },
        // Text & Outlined Button
        {
          'hover:bg-surface-300/20':
            (props.text || props.outlined) && props.severity === 'secondary' && !props.plain
        },

        // Success
        {
          'hover:bg-green-600 dark:hover:bg-green-300 hover:border-green-600 dark:hover:border-green-300':
            props.severity === 'success' && !props.text && !props.outlined && !props.plain
        },
        {
          'focus-visible:ring-green-400/50 dark:focus-visible:ring-green-300/50':
            props.severity === 'success'
        },
        // Text & Outlined Button
        {
          'hover:bg-green-300/20':
            (props.text || props.outlined) && props.severity === 'success' && !props.plain
        },

        // Info
        {
          'hover:bg-blue-600 dark:hover:bg-blue-300 hover:border-blue-600 dark:hover:border-blue-300':
            props.severity === 'info' && !props.text && !props.outlined && !props.plain
        },
        {
          'focus-visible:ring-blue-400/50 dark:focus-visible:ring-blue-300/50':
            props.severity === 'info'
        },
        // Text & Outlined Button
        {
          'hover:bg-blue-300/20':
            (props.text || props.outlined) && props.severity === 'info' && !props.plain
        },

        // Warning
        {
          'hover:bg-orange-600 dark:hover:bg-orange-300 hover:border-orange-600 dark:hover:border-orange-300':
            props.severity === 'warning' && !props.text && !props.outlined && !props.plain
        },
        {
          'focus-visible:ring-orange-400/50 dark:focus-visible:ring-orange-300/50':
            props.severity === 'warning'
        },
        // Text & Outlined Button
        {
          'hover:bg-orange-300/20':
            (props.text || props.outlined) && props.severity === 'warning' && !props.plain
        },

        // Help
        {
          'hover:bg-purple-600 dark:hover:bg-purple-300 hover:border-purple-600 dark:hover:border-purple-300':
            props.severity === 'help' && !props.text && !props.outlined && !props.plain
        },
        {
          'focus-visible:ring-purple-400/50 dark:focus-visible:ring-purple-300/50':
            props.severity === 'help'
        },
        // Text & Outlined Button
        {
          'hover:bg-purple-300/20':
            (props.text || props.outlined) && props.severity === 'help' && !props.plain
        },

        // Danger
        {
          'hover:bg-red-600 dark:hover:bg-red-300 hover:border-red-600 dark:hover:border-red-300':
            props.severity === 'danger' && !props.text && !props.outlined && !props.plain
        },
        {
          'focus-visible:ring-red-400/50 dark:focus-visible:ring-red-300/50':
            props.severity === 'danger'
        },
        // Text & Outlined Button
        {
          'hover:bg-red-300/20':
            (props.text || props.outlined) && props.severity === 'danger' && !props.plain
        },

        // GB Themed Buttons
        {
          'bg-primary-400 text-white hover:bg-primary-500 focus-visible:ring-primary-500':
            attrs['gb-theme'] === 'bluePrimary',
          'bg-purple-300 text-white hover:bg-purple-400 focus-visible:ring-purple-400':
            attrs['gb-theme'] === 'purplePrimary',
          'bg-green-300 text-white hover:bg-green-400 focus-visible:ring-green-400':
            attrs['gb-theme'] === 'greenPrimary',
          'bg-red-300 text-white hover:bg-red-400 focus-visible:ring-red-400':
            attrs['gb-theme'] === 'redPrimary',
          'bg-transparent text-gray-900 border border-gray-400 hover:bg-gray-300 hover:border-gray-500 focus-visible:ring-gray-700':
            attrs['gb-theme'] === 'grayOutlineSecondary',
          'bg-white border border-primary-400 text-primary-400 hover:bg-gray-300 hover:border-primary-500 hover:text-primary-500 focus-visible:ring-primary-500 focus-visible:bg-gray-300 focus-visible:text-primary-500':
            attrs['gb-theme'] === 'blueOutlineSecondary',
          'bg-transparent border border-purple-300 hover:bg-gray-300 hover:border-purple-400 text-purple-400 focus-visible:ring-purple-400':
            attrs['gb-theme'] === 'purpleOutlineSecondary',
          'bg-transparent border border-green-300 hover:bg-gray-300 hover:border-green-400 text-green-400 focus-visible:ring-green-400':
            attrs['gb-theme'] === 'greenOutlineSecondary',
          'bg-transparent border border-red-300 hover:bg-gray-300 hover:border-red-400 text-red-400 focus-visible:ring-red-400':
            attrs['gb-theme'] === 'redOutlineSecondary',
          'bg-gray-200 text-gray-900 hover:bg-gray-300 focus-visible:ring-primary-500':
            attrs['gb-theme'] === 'grayFillSecondary',
          'bg-blue-200 text-gray-900 hover:bg-blue-300 focus-visible:ring-primary-500':
            attrs['gb-theme'] === 'blueFillSecondary',
          'bg-purple-100 text-gray-900 hover:bg-purple-200 focus-visible:ring-purple-400':
            attrs['gb-theme'] === 'purpleFillSecondary',
          'bg-transparent text-gray-900 hover:bg-gray-300 focus-visible:ring-gray-700 focus-visible:bg-gray-300':
            attrs['gb-theme'] === 'grayTertiary',
          'bg-transparent text-primary-400 hover:bg-gray-300 hover:text-primary-500 focus-visible:ring-primary-500':
            attrs['gb-theme'] === 'blueTertiary',
          'bg-transparent text-purple-300 hover:bg-gray-300 hover:text-purple-400 focus-visible:ring-purple-400':
            attrs['gb-theme'] === 'purpleTertiary',
          'bg-transparent text-green-300 hover:bg-gray-300 hover:text-green-400 focus-visible:ring-green-400':
            attrs['gb-theme'] === 'greenTertiary',
          'bg-transparent text-red-300 hover:bg-gray-300 hover:text-red-400 focus-visible:ring-red-400':
            attrs['gb-theme'] === 'redTertiary',
          'bg-gradient-to-r from-ai-bluePinkStart to-ai-bluePinkStop text-white hover:from-ai-bluePinkStart hover:to-ai-bluePinkStop focus-visible:ring-primary-400':
            attrs['gb-theme'] === 'aiPrimary',
          'bg-transparent text-gray-900 border [border-color:transparent] bg-[linear-gradient(white,white),linear-gradient(to_top_right,theme(colors.ai.bluePinkStart),theme(colors.ai.bluePinkStop))] bg-origin-border [background-clip:padding-box,border-box] hover:bg-[linear-gradient(theme(colors.gray.300),theme(colors.gray.300)),linear-gradient(to_top_right,theme(colors.ai.bluePinkStart),theme(colors.ai.bluePinkStop))] focus-visible:ring-primary-500':
            attrs['gb-theme'] === 'aiSecondary'
        },

        // Disabled
        {
          'opacity-60 pointer-events-none cursor-not-allowed':
            context.disabled || attrs['aria-disabled'] === 'true'
        },

        // Transitions
        'transition duration-200 ease-in-out',

        // Misc
        'cursor-pointer overflow-hidden select-none'
      ]
    }
  },
  label: ({ props }) => ({
    class: [
      'duration-200',
      {
        'hover:underline': props.link
      },
      { 'flex-1': props.label !== null, 'invisible w-0': props.label == null }
    ]
  }),
  badge: ({ props }) => ({
    class: [{ 'ml-2 w-4 h-4 leading-none flex items-center justify-center': props.badge }]
  })
}
